<inthraction-employee-dashboard *ngIf="manager && employee" [employee]="employee" [manager]="manager" (showObjectiveResponseDistributions)="showObjectiveResponseDistributions($event)"></inthraction-employee-dashboard>
